module.exports = __webpack_public_path__ + "9d02a9ef7513d21187c3981c8d20e3aa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gb-nir.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gb-nir.svg
// module chunks = 0